import {
  Building2,
  Target,
  Facebook,
  LayoutTemplate,
  TrendingUp,
  Search,
  HeartPulse,
  GraduationCap,
} from "lucide-react";

const SERVICES = [
  {
    icon: Building2,
    title: "Real Estate Lead Generation",
    desc: "Hyper-targeted campaigns built for developers, builders, and channel partners — designed to deliver site-visit-ready buyers.",
    testid: "service-real-estate-lead-gen",
  },
  {
    icon: Target,
    title: "Google Ads",
    desc: "Search, Display, YouTube & PMax campaigns optimised for high-intent property buyers across Pune and beyond.",
    testid: "service-google-ads",
  },
  {
    icon: Facebook,
    title: "Meta Ads",
    desc: "Facebook & Instagram ads with creatives that stop the scroll and lead forms that capture serious prospects.",
    testid: "service-meta-ads",
  },
  {
    icon: LayoutTemplate,
    title: "Landing Page Development",
    desc: "Fast-loading, conversion-optimized landing pages designed specifically for real estate inquiry capture.",
    testid: "service-landing-pages",
  },
  {
    icon: TrendingUp,
    title: "Performance Marketing",
    desc: "Full-funnel performance strategy with rigorous tracking, A/B testing, and continuous CPL reduction.",
    testid: "service-performance-marketing",
  },
  {
    icon: Search,
    title: "SEO Services",
    desc: "Local SEO and project-page optimization to dominate Pune real estate keywords organically.",
    testid: "service-seo",
  },
  {
    icon: HeartPulse,
    title: "Healthcare Marketing",
    desc: "Patient acquisition campaigns for hospitals, clinics, and specialists with compliant ad strategy.",
    testid: "service-healthcare",
  },
  {
    icon: GraduationCap,
    title: "Education Marketing",
    desc: "Admission-driving campaigns for schools, colleges, and coaching institutes across India.",
    testid: "service-education",
  },
];

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="section-pad bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-orange mb-3">
            What We Do
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy leading-tight tracking-tight">
            Services built for{" "}
            <span className="text-blue">real estate growth</span>
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600">
            Every service is engineered around one goal: qualified leads that convert into bookings.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.testid}
                data-testid={s.testid}
                className="service-card group relative bg-white border border-slate-200 rounded-2xl p-6 cursor-pointer"
              >
                <div className="icon-wrap w-12 h-12 rounded-xl bg-orange/10 text-orange flex items-center justify-center mb-5">
                  <Icon size={22} />
                </div>
                <h3 className="text-lg font-bold text-navy mb-2 leading-snug">{s.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                <div className="mt-5 inline-flex items-center text-xs font-semibold uppercase tracking-wider text-slate-400 group-hover:text-orange transition-colors">
                  Learn more →
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
